export const locale = {
  lang: 'zh2',
  data: {
    'RESULTADOS': {
      'TITULO':	'报告',
      'DESCRIP':	'选择一个选项',
      'CARGANDO': '加载公司调查结果',
      'COMINGSOON': 'COVID调查结果即将发布...',
      'VALIDANDO': {
        'BOTON': '在验证过程中',
        'MENSAJE': '该产品的结果正在验证过程中，很快就会为您提供',
      },

      'TABLAPRODUCTOS':{
        'COL1':'年',
        'COL2':'访问',
        'BOT': '访问',
      },

      'SECCIONES': {
        'TITULO_VER':'版 ',
        'NOSECCIONES':	'没有可用部分',

        'CERTIFICAR': {
          'TITULO': '证书',
          'INFO': '选择您要咨询的年份',
          'BOTON': '输入'
        },
        'MEDIR': {
          'TITULO': '措施',
          'INFO': '选择您要咨询的年份',
          'BOTON': '输入'
        },
        'PULSE': {
          'TITULO': '新闻检查',
          'INFO': '选择您要咨询的年份',
          'BOTON': '输入'
        },
        'MEDIR_AMCO': {
          'TITULO': 'ICI',
          'INFO': '选择您要咨询的年份',
          'BOTON': '输入'
        },
        'MEDIR_INNO': {
          'TITULO': '动感调查',
          'INFO': '选择您要咨询的年份',
          'BOTON': '输入'
        },
        'CertiAdicio': {
          'TITULO': '其他认证',
          'INFO': '选择您要咨询的年份',
          'BOTON': '输入'
        },
        'Amco': {
          'TITULO': 'AMCO',
          'INFO': '选择您要咨询的年份',
          'BOTON': '输入'
        },
        'TrabDign': {
          'TITULO': '体面的工作',
          'INFO': '选择您要咨询的年份',
          'BOTON': '输入'
        },
        'PrimEmp': {
          'TITULO': '第一份工作',
          'INFO': '选择您要咨询的年份',
          'BOTON': '输入'
        },
        'GOFLOW': {
          'TITULO': '结果 GoFlow',
          'INFO': '选择您要咨询的年份',
          'BOTON': '输入'
        },
      },
      'TABPRIN':{
       'TABPRO':'认证过程',
        'TAB4ALL':'全部结果',
        'TAB4ALL2':'处理结果',
        'TITURES': '全部结果',
        'TABCER':'測量過程',
        'TABPULSE':'脈衝檢查程序',
        'TABICI': 'ICI结果',
        'TABINNO': '动感调查结果',
        'TABAMCO': 'AMCO 流程',
        'TABTRABDIG':'体面的工作流程',
        'TABPRIEMP':'首次就业流程',
      },

      '4ALLVIEJAS':{
       'TITULO': '永远继承的结果',
       'BOTON': 'Start',
       'SIN_4ALL_HEREDADAS':"您不指望继承的Forall结果",
       'TITULOCERTIFICAR':'证明',
       'APLICACIONANIO':'申请年份：2019',
      },

      '4ALL':{
        'TITULO4ALL':'实践结果',
        'TABPRACTICAS':{
          'TITULOTAB':'4全部实践',
          'TITULOPRACGLOBAL':{
            'SUBTITULOPRAC':'FORALL做法的全球结果',
            'TEXTO1':'百分比',
            'TEXTO2': '了解FORALL惯例',
            'TEXTO3': '在您的组织中',
            'TEXTO4': 'Level of',
            'TEXTO5':'他们认识的合作者的满意度',
            'TEXTO6':'FORALL惯例',
          },
          'TITULOPRAC4All':{
            'TITULOTAB':'受众特征',
            'SUBTITULO4ALL':'FORALL做法的结果',
            'TITULOCONO':'知识',
            'TEXTO1':'您组织中FORALL实践的知识百分比',
            'TITULOSATIS':'满足',
            'TEXTO2':'了解FORALL惯例的员工的满意度',
          }
        },

        'DEMOGRAFICOS':{
          'Cargo homologado ':'批准的货物',
          'Años de Trabajo':'古董',
          'Condición de trabajo':'工作条件',
          'Tipo de trabajo':'补偿方案',
          'Género':'性别',
          'Educación':'学术学位',
          'PORCONOTXT1':'百分比',
          'PORCONOTXT2':'了解FORALL做法',
          'PORCONOTXT3':'按受众特征划分',
          'PORSATITXT1':'等级',
          'PORSATITXT2':'了解FORALL惯例的合作者的满意度',
          'PORSATITXT3':'按受众特征划分',
        },
        'MODL_N_RESU':'目前没有结果',
        'MODL_N_RESU_4ALL':'无法显示要求的结果',

      },
      "ETIQ_MODAL_RESULT":{
        "TITLE_MODA":'没有找到结果平台键',
         "ETQ_PROD": "产品：",
         "ETQ_BROK": "经纪人：",
         "ETQ_COUN": "国家：",
         "ETQ_LANG": "语言：",
         "ETQ_CERTY": "证书：",
         "true":"启用",
         "false": "已禁用",
         "COUNTR_NO_SELEC":"*未选中的*",
      }
    },
    'CONFING_RESUL':{
    'TITULO_MODAL':'BenchMarks 结果配置',
    'TAB_DEMO_EXCEL':'Excel人口统计',
    'SUB_TIT_TAB_DEMO_EXCEL':'选择受众特征：',
    'TAB_DEMO_ENCU':'人口统计调查',
    'SUB_TIT_TAB_DEMO_ENCU':'选择受众特征：',
    'TAB_BENCHMA':'基准',
    'SUB_TIT_TAB_BENCHMA':'',
    'TITULO_MAT_EXPAN_TAMANO':'最佳',
    'TITULO_MAT_EXPAN_SECTOR':'部门性的',
    'TITULO_MAT_EXPAN_REGIONAL':'范围',
    'OKSELECT':'选中',
    'NOTSELECT':'未选择',
    'TAB_NIV_GEOG':'地理等级',
    'SUB_TIT_TAB_NIV_GEOG':'选择地理级别：',
    'TAB_NIV_ESTRUC':'结构层次',
    'SUB_TIT_TAB_NIV_ESTRUC':'选择结构级别：',
    'BTN_ACEPTAR':'接受',
    'MODAL_CARGA_DEMO_EXC':'载入人口统计资料',
    'MODAL_CARGA_DEMO_ENC':'正在加载调查受众特征',
    'MODAL_CARGA_BENCH':'载入基准',
    'MODAL_CARGA_NIV_GEO':'加载地理级别',
    'MODAL_CARGA_NIV_ESTR':'加载结构层',
    'TAB_BENCH_MARK':'基准',
    'MODAL_CARGA_BENCH_MARK':'加载基准',
    'SUB_TIT_TAB_BENCH_MARK':'选择基准',
    'SUCCES_GUAR_SELEC':'修改已正确保存',
    'CONFI_GUAR_SELE':'¿确定要保存所做的更改吗？',
    'RES_SI':'是',
    'RES_NO':'否',
    'MAT_TOOL_BTN_CONFI_RESULT':'结果配置',
    'MODAL_GUA_INFOR':'保存信息',
    'SUB_TIT_TAB_HIERARCHI':'层次路径选择：',
    'MODAL_CARGA_HIERARCHI':'加载层次路径',
    'SIN__HIERARCHI_MOSTRAR':'hierarchyPaths 中目前没有结果',
    'EXTERNAL_PORTAL':'复制外部4all的url',
    'INTRU_TEX_BENCHMARK':'*移动基准',
       'BENCHMARCK_SELEC':'按呈现顺序选择的BenchMark：',
       'BTN_SAV_BENCH':'保存基准',
       'TEX_SEARC_BENCH_TOP':'输入顶级基准进行搜索',
       'TEX_SEARC_BENCH_SECT':'输入扇区基准进行搜索',
       'TEX_SEARC_BENCH_RANG':'输入要搜索的基准范围',
       'INFO_MAS_BENCH_ESPA':'组基准',
       'BTN_ADD_BENCH_SUGE':'添加建议',
       'MOD_WARN_MAX_PERMIT':'无法添加，因为超过了允许的空格数',
       'MOD_WARN_UN_CATE':'当前已存在所选类别的基准',
       'MOD_WARN_NO_APLIC':'无法添加它，因为不选择基准的选项已启用。',
       'INSTRU_DRAP&DROP_1':'将 BenchMark 拖放到此处',
       'LABE_CIRC_PROGRE':'基准',
       'LABE_INSTRU_SELECT_BENCH':'¿您想选择 BenchMark 吗？',
  },
  'CONFING_RESUL_GOFLOW':{
  'TITULO_MODAL':'GoFlow 结果信息',
    },
  'CONFING_RESUL_EMP':{
    'TITULO_MODAL':'原始数据启发',
           'INT_TEX':'说明：请上传要导入的原始数据文件',
           'TOOLT_CHA_INF':'我选择了文件',
           'UPLO_INF':'导入行数据',
           'SUCC_UPLO_INF':'导入成功',
  }
  }
};
